import { render, staticRenderFns } from "./ConnectomeIcon.vue?vue&type=template&id=205b9d9b&"
import script from "./ConnectomeIcon.vue?vue&type=script&lang=ts&"
export * from "./ConnectomeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports